import React from "react";
import "../../nav/Navigation.css";
import { NavLink } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";

function SuperAdminNav() {
    return (
        <Container>
            <Nav variant="tabs" className="mb-2 mr-auto sub-menu-nav">
                <NavLink className="nav-link" to="/admin-home/stats">
                    Stats
                </NavLink>
                <NavLink className="nav-link" to="/admin-home/users">
                    Users
                </NavLink>
                <NavLink className="nav-link" to="/admin-home/pubs">
                    Pubs
                </NavLink>
                <NavLink className="nav-link" to="/admin-home/points-config">
                    Points Config
                </NavLink>
            </Nav>
        </Container>
    );
}

export default SuperAdminNav;
